import TemplateInfoTooltip from "./TemplateInfoTooltip";

export default TemplateInfoTooltip;
